import { Injectable } from '@angular/core';
import { defaultMxISR, defaultMxMonthISR, UMA } from "../models/taxes/2026";
import { defaultBenefits } from "../models/benefit";

@Injectable({
  providedIn: 'root'
})
export class TaxService {

  constructor() { }

  findTax(amount) {
    return defaultMxISR.find(tax => (amount >= tax.minLimit && amount <= tax.maxLimit));    
  }
  
  findMonthTax(amount) {
    return defaultMxMonthISR.find(tax => (amount >= tax.minLimit && amount <= tax.maxLimit));    
  }

  calculateTax(amount) {
    if (isNaN(amount) || amount <= 0) {
      return 0;
    }
    const tax = this.findTax(amount);
    const base = amount - tax.minLimit;
    const result = base * (tax.percent/100);
    return +(result + tax.fixedFee).toFixed(2);
  }
  
  calculateMonthTax(amount) {
    if (isNaN(amount) || amount <= 0) {
      return 0;
    }
    const tax = this.findMonthTax(amount);
    const base = amount - tax.minLimit;
    const result = base * (tax.percent/100);
    return +(result + tax.fixedFee).toFixed(2);
  }

  calculateChristmasBonusTax(amount, christmasBonusDays) {
    if (!christmasBonusDays || isNaN(christmasBonusDays) || christmasBonusDays == 0) {
      return 0;
    }
    const benefit =  defaultBenefits.find(benefit => 1 === benefit.id);
    const exentSalary = benefit.taxConfig.umaDaily * UMA.daily;

    const proportionalSalary = (amount / 30) * christmasBonusDays;
    const proportionalSalaryWithExent = proportionalSalary - exentSalary;
    
    const proportionalSalaryTax = this.calculateMonthTax(amount + proportionalSalaryWithExent);
    const ordinaryMonthTax = this.calculateMonthTax(amount);
    return +(proportionalSalaryTax - ordinaryMonthTax).toFixed(2);
  }

  calculateVacationBonusTax(amount, vacationDays, percent) {
    if (!vacationDays || isNaN(vacationDays) || vacationDays == 0) {
      return 0;
    }
    
    if (!percent || isNaN(percent) || percent == 0) {
      return 0;
    }

    const proportionalSalary = (amount / 30) * vacationDays;
    const proportionalBonus = proportionalSalary * (percent / 100);

    const benefit =  defaultBenefits.find(benefit => 2 === benefit.id);
    const exentBonus = benefit.taxConfig.umaDaily * UMA.daily;
    const proportionalBonusWithExent = proportionalBonus - exentBonus;

    const proportionalBonusTax = this.calculateMonthTax(amount + proportionalBonusWithExent);
    const ordinaryMonthTax = this.calculateMonthTax(amount);
    
    return +(proportionalBonusTax - ordinaryMonthTax).toFixed(2);
  }

  calculatePerformanceBonusTax(amount, bonus) {
    const ordinaryMonthTax = this.calculateMonthTax(amount);
    const ordinaryAndBonusMonthTax = this.calculateMonthTax(amount + bonus);
    return +(ordinaryAndBonusMonthTax-ordinaryMonthTax).toFixed(2);
  }
}
